import { forwardRef, useMemo, useState } from "react";

import { InputIcon } from "../inputIcon";
import { TextInput } from "../textInput";

import type { Ref } from "react";

import type { IPasswordProps } from "./types";

export const Password = forwardRef(function Password(
  props: IPasswordProps,
  ref: Ref<HTMLInputElement>,
) {
  const { disabled, readOnly, ...rest } = props;

  const [show, setShow] = useState(false);

  const Icon = useMemo(() => {
    if (disabled || readOnly) {
      return;
    }
    return (
      <InputIcon
        tabIndex={-1}
        iconName={show ? "EyeCloseLine" : "EyeLine"}
        onClick={() => {
          setShow((prev) => !prev);
        }}
      />
    );
  }, [disabled, readOnly, show]);

  return (
    <TextInput
      type={show && !disabled && !readOnly ? "text" : "password"}
      iconName={"Lock2Line"}
      disabled={disabled}
      readOnly={readOnly}
      endChildren={Icon}
      ref={ref}
      {...rest}
    />
  );
});
